import React, {useContext, useState} from 'react';
import {Card} from "../../../../../../components/card/card.jsx";
import Button from "../../../../../../components/button/button.jsx";
import {FaPlus} from "react-icons/fa";
import {AgGridReact} from "ag-grid-react";
import aggridUtils from "../../../../../../utils/aggrid-utils.js";
import {Modal} from "../../../../../../components/modal/modal.jsx";
import SentryRow from "../../../../../../components/template/sentry-row.jsx";
import {IndividualContext} from "../../individual-context.jsx";
import {v4 as uuidv4} from "uuid";
import ConfirmationDeleteList from "../../../../../../components/utils/confirmation-delete-lists.jsx";
import projectUtils from "../../../../../../utils/project-utils.js";
import GenericEditRemoveCellRenderer
    from "../../../../agents/form/components/tabs/generic-edit-remove-cell-renderer.jsx";
import SelectComponent from "../../../../../../components/select/select-component.jsx";
import optionsUtils from "../../../../../../utils/options-utils.js";
import InputForm from "../../../../../../components/input/input-form.jsx";
import {MaskDefault} from "../../../../../../utils/mask.js";

const initialData = () => ({
    itemId: uuidv4(),
    data: "",
    type: "",
});

const Phones = () => {
    const {individual, setIndividual, setChanges} = useContext(IndividualContext)
    const [openModal, setOpenModal] = useState(false)
    const [data, setData] = useState(initialData)

    const onChangeCustom = (value, id) => setData(prev => ({...prev, [id]: value}))
    const onChange = ({target: {id, value}}) => setData(prev => ({...prev, [id]: value}));

    const remove = (data) => {
        ConfirmationDeleteList(() => {
            setIndividual(prev => ({
                ...prev,
                phones: prev.phones.filter(dep => dep.itemId !== data.itemId)
            }));
        })

        setChanges(prev => (prev.includes("phones") ? prev : [...prev, "phones"]))
    }

    const [columnDefs] = useState([
        { headerName: "Tipo", field: "type", comparator: aggridUtils.nullLastComparator },
        { headerName: "Número", field: "data", flex: 1, comparator: aggridUtils.nullLastComparator },
        {
            headerName: "", field: "", width: 90,
            cellRenderer: GenericEditRemoveCellRenderer,
            cellRendererParams: {setData, setOpen: setOpenModal, remove}
        },
    ]);

    const save = () => {
        let message = ""
        if (!data.data) message = "O campo \"Número\" é obrigatório."
        if (!data.type) message = "O campo \"Tipo\" é obrigatório."

        if (message) {
            projectUtils.swalErrorMessage("", message, "Ok");
            return
        }

        setIndividual(prevItems => {
            const exists = prevItems.phones.some(t => t.itemId === data.itemId);

            const updated = exists
                ? prevItems.phones.map(t => (t.itemId === data.itemId ? data : t))
                : [...prevItems.phones, data];

            return {
                ...prevItems,
                phones: updated
            }
        });

        setChanges(prev => (prev.includes("phones") ? prev : [...prev, "phones"]))
        onHide()
    }

    const onHide = () => {
        setData(initialData);
        setOpenModal(false)
    }

    return (
        <>
            <Card>
                <Card.Header className={"gap-2"}>
                    <Card.Title>Telefones</Card.Title>
                    <Button className="h-7.5! w-7.5 p-0!" onClick={() => setOpenModal(true)}>
                        <FaPlus/>
                    </Button>
                </Card.Header>
                <Card.Body>

                    <div className={"h-[calc(100vh-195px)]"}>
                        <AgGridReact
                            rowData={individual.phones}
                            columnDefs={columnDefs}
                            animateRows={false}
                            suppressCellFocus={true}
                            gridOptions={{localeText: aggridUtils.localization()}}
                            theme={aggridUtils.generalTheme()}
                        />
                    </div>
                </Card.Body>
            </Card>

            <Modal overflow={true} isCloseClick={false} open={openModal} setOpen={onHide}  title={"Telefone"} className={"w-3/12"}>
                <Modal.Body>
                    <SentryRow>
                        <div className="col-span-12">
                            <SelectComponent
                                id={"type"}
                                value={optionsUtils.typePhones.find(option => option.value === data.type)}
                                options={optionsUtils.typePhones}
                                label={"Tipo *"}
                                onChange={(selected) => onChangeCustom(selected?.value, "type")}
                            />
                        </div>

                        <div className="col-span-12">
                            <InputForm
                                id="data"
                                value={data.data}
                                label="Número *"
                                onBlur={onChange}
                                onChange={onChange}
                                mask={MaskDefault.phone}
                            />
                        </div>
                    </SentryRow>
                </Modal.Body>

                <Modal.Footer className={"p-1"}>
                    <div className={"w-full flex justify-end"}>
                        <Button onClick={save}>
                            Confirmar
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default Phones;